import React, { PropsWithChildren, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { EPerformanceEvaluationStatus, EPerformanceFormStatus, EStatus } from '@common/definitions';
import { EPulseSurveyStatus } from '@modules/survey/types/objects';
import { ESurveyStatus } from '@modules/survey/definitions';
import { Icon, IconTypes } from '../icon';
import { Badge as ShadcnBadge } from '../ui/badge';
import { cn } from '@common/lib/utils';

export type BadgeProps = PropsWithChildren<{
  status?: EStatus | EPulseSurveyStatus | ESurveyStatus | EPerformanceFormStatus | EPerformanceEvaluationStatus;
  icon?: IconTypes;
  text?: string;
  className?: string;
}>;

// Can be expanded to show other types of badges besides status
function Badge({
 status, icon, text, children, className
}: BadgeProps) {
  const { t } = useTranslation();

  if (status) {
    return (
      <ShadcnBadge variant={status as any} className={className}>
        {t('common:status', { context: status })}
      </ShadcnBadge>
    );
  }

  return (
    <ShadcnBadge
      variant="outline"
      className={cn('tw-bg-gray-custom-100 tw-text-gray-custom-500 tw-border-transparent', className)}
    >
      {icon && <Icon className="tw-mr-2 tw-leading-6" size={20} type={icon} />}
      {text || children}
    </ShadcnBadge>
  );
}

export default memo(Badge);
